import React, { useContext } from 'react';

import {
  AddressDisplay, FullNameDisplay, NotProvided, PersonalInfoSection
} from '../../components';
import { AddressContext, IdentityContext } from '../../context';

export function PersonalInfoDisplay() {
  const { person } = useContext(IdentityContext);
  const { address } = useContext(AddressContext);

  const idVerified = true || person?.id_verified;

  console.log('PersonalInfoDisplay', person, address);

  return (
    <div className="personal-info-display">
      <div className="section-overview">
        <p>
          Please review your personal information below and make sure everything is correct for your
          legal documents.
        </p>
      </div>
      <PersonalInfoSection label="Full Name" verified={idVerified} value={<FullNameDisplay person={person} />} />
      <PersonalInfoSection label="Address" verified={true} value={<AddressDisplay address={address} />} />
      <PersonalInfoSection
        label="Phone Number"
        verified={true}
        value={person?.contactPhone || <NotProvided />}
      />
      <PersonalInfoSection
        label="Email Address"
        verified={true}
        value={person?.contactEmail || <NotProvided />}
      />
    </div>
  );
}
